import React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { Text } from "../../Ui/Text";
import IOSBtn from "../../../../../public/images/redirectToAppsButtons/AppStore.png";
import Android from "../../../../../public/images/redirectToAppsButtons/PlayStore.png";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    bottomPanel: {
      backgroundColor: "#20a8ae",
      width: "100%",
      marginTop: "17px",
      height: "158px",
      [breakpoints.down(321)]: {
        marginTop: "10px",
        height: "142px"
      }
    },
    headingText: {
      fontSize: "22px",
      lineHeight: 1.17,
      color: "#ffffff",
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "18px",
      height: "52px",
      width: "329px",
      [breakpoints.down(321)]: {
        fontSize: "18px",
        height: "42px",
        width: "265px"
      }
    },
    item: {
      display: "flex",
      justifyContent: "center"
    },
    btnLeftMargin: {
      display: "flex",
      justifyContent: "center",
      width: "44px",
      [breakpoints.down(321)]: {
        width: "28px"
      }
    },
    btnRightMargin: {
      display: "flex",
      justifyContent: "center",
      width: "43px",
      [breakpoints.down(321)]: {
        width: "28px"
      }
    },
    IOSBtnImage: {
      width: "150px",
      height: "50px",
      [breakpoints.down(321)]: {
        width: "120px",
        height: "40px"
      }
    },
    AndroidBtnImage: {
      width: "167px",
      height: "50px",
      [breakpoints.down(321)]: {
        width: "134px",
        height: "40px"
      }
    },
    btnGrops: {
      display: "flex",
      justifyContent: "center"
    }
  });
});
export const MobileAppsRedirectButtonGroup = (env) => {
  const classes = useStyles({});
  
  return (
    <React.Fragment>
      <div className={classes.bottomPanel}>
        <div style={{ padding: "20px 0 0 0" }}>
          <Text variant="h5" className={classes.headingText}>
            For the best way to view your tickets, get the app today!
          </Text>
        </div>
        <div className={classes.btnGrops}>
          <div className={classes.btnLeftMargin}></div>
          <div className={classes.item}>
            <a href={env.IOS_APP_STORE_LINK}>
              <img src={IOSBtn} className={classes.IOSBtnImage} />
            </a>
          </div>
          <div className={classes.item} style={{ width: "10px" }}></div>
          <div className={classes.item}>
            <a href={env.GOOGLE_PLAY_APP_LINK}>
              <img src={Android} className={classes.AndroidBtnImage} />
            </a>
          </div>
          <div className={classes.btnRightMargin}></div>
        </div>
      </div>
    </React.Fragment>
  );
};
